/*
 * Copyright © 2025. TapClicks Inc. All rights reserved.
 *
 * Author: Rajesh Chittampally
 */

export const InsightsHqRoute = {
  INSIGHTS_HQ: 'insightshq',
  FILTERS_VIEW: 'view', // backend route
  SAVE_FILTERS: 'savefilters', // backend route
};

export const InsightsHqPathName = {
  INSIGHTS_HQ: 'insightshq',
};

export const InsightsHqFilterTags = {
  ALL: i18n.$t('All'),
  NOT_REVIEWED: i18n.$t('Not Reviewed'),
  REVIEWED: i18n.$t('Previously Reviewed'),
};

export const InsightsHqReviewedStatus = {
  NOT_REVIEWED: 'notreviewed',
  REVIEWED: 'reviewed',
};

export const InsightsHqFilterTypes = {
  CLIENT: 'client',
  CLIENT_GROUP: 'clientGroup',
  CLUSTER: 'cluster',
  SMART_CAMPAIGN: 'smartCampaign',
  DATASOURCE: 'dataSource',
};

export const InsightsHqFilterFormFields = {
  ID: 'id',
  AND: 'and',
  IN: 'in',
};

export const PredefinedFilterName = 'is_marked_reviewed';

export const userActions = {
  LIKE: 'like',
  DISLIKE: 'dislike',
};

export const likeRatingDetails = {
  clear_and_actionable: i18n.$t('Clear and Actionable'),
  relevant: i18n.$t('Relevant'),
  detailed_enough: i18n.$t('Detailed Enough'),
  easy_to_implement: i18n.$t('Easy to Implement'),
  new_insight: i18n.$t('New Insight'),
  other: i18n.$t('Other'),
};

export const disLikeRatingDetails = {
  irrelevant: i18n.$t('Irrelevant'),
  too_complex: i18n.$t('Too Complex'),
  requires_more_context: i18n.$t('Requires More Context'),
  confusing: i18n.$t('Confusing'),
  low_impact: i18n.$t('Low Impact'),
  other: i18n.$t('Other'),
};

export const ScoresLabels = {
  EXPOSURE: 'Exposure',
  ENGAGEMENT: 'Engagement',
  PERFORMANCE: 'Performance',
  COST: 'Cost',
  SPEND: 'Spend',
};

export const ScoresLabelColors = {
  BLUE: '#007bff',
  YELLOW: '#f39c12',
  NAVY: '#34495e',
  GREEN: '#2ecc71',
  RED: '#e74c3c',
};

export const ComparisonColors = {
  GREEN: '#2fcd72',
  RED: '#f75769',
};

export const Rating = {
  MAX_RATING: 5,
  THRESHOLD_RATING: 6,
};

export const ScoresTooltips = {
  EXPOSURE: i18n.$t(
    'Measures how effectively your ads are reaching the target audience. A higher score indicates strong visibility across your selected platforms.'
  ),
  ENGAGEMENT: i18n.$t(
    'Assesses how users interact with your ads, including clicks, shares, and likes. A higher score suggests strong audience engagement.'
  ),
  PERFORMANCE: i18n.$t(
    'Evaluates the overall effectiveness of your campaign, based on CTR, conversion rates, and audience response. A higher score indicates successful ad performance.'
  ),
  COST: i18n.$t(
    'Analyzes cost efficiency across campaigns. A high score means your budget is well-optimized for maximum returns, while a low score may indicate overspending.'
  ),
  SPEND: i18n.$t(
    'Examines how well your budget is allocated and utilized. A balanced spend strategy results in a higher score, ensuring efficient ad distribution.'
  ),
};

export const DisclaimerText =
  'Disclaimer: This is machine-generated content and intended as a suggestion. Apply human intelligence for final analysis and decisions.';

export const InvertedComparisonMetrics = ['CPC'];

export const NeutralComparisonMetrics = ['Spend'];

export const FrontEndSearchValues = [
  'headline',
  'description',
  'expected_impact',
  'business_impact',
  'data_source',
  'vendor_account_name',
  'next_step',
  'metric_name',
];

export const HelpTexts = {
  SEARCH_CUSTOM_PLACEHOLDER: i18n.$t('Search recommendations'),
  EMPTY_LIST_MESSAGE: i18n.$t(
    'No client filter is selected. Please select a client to see insights'
  ),
  FRONT_END_FILTER_EMPTY_LIST_MESSAGE: i18n.$t(
    'No recommendations match your search. Try a different keyword.'
  ),
};
